import {types} from './types';

export const blurPage = (shouldBlur) => {
    return {
        type: types.BLUR_PAGE,
        payload: shouldBlur
    }
}


// WEBPACK FOOTER //
// ./src/js/actions/blur-actions.js